var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("artwork-slideshow", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.active,
        expression: "active",
      },
    ],
    ref: "slideshow",
    attrs: { items: _vm.items, index: _vm.index, active: _vm.active },
    on: {
      "next-page": _vm.onNextPage,
      "prev-page": _vm.onPrevPage,
      close: _vm.onClose,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }